import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';
import * as board from './types';

const mutations = {
  [board.SET_ARTICLE](state, data) {
    if (data) {
      data.createdAt = format(parseISO(data.createdAt), 'yyyy-MM-dd');
    }

    state.article = data;
  },
  [board.SET_ARTICLES](state, data) {
    const { toArticles2 } = data;
    const { toArticles3 } = data;
    let startIdx = data.pagination.startReverseIndex;
    let target = state.articles;
    if (toArticles2) target = state.articles2;
    if (toArticles3) target = state.articles3;
    if (data.content) {
      data.content.forEach(element => {
        element.idx = startIdx--;
        if (element.createdAt) {
          element.createdAt = format(parseISO(element.createdAt), 'yyyy-MM-dd');
        }
        if (element.updatedAt) {
          element.updatedAt = format(parseISO(element.updatedAt), 'yyyy-MM-dd');
        }
      });
    }

    console.log('[SET_ARTICLES]');
    console.log(data);

    target.content = data.content;
    target.pagination = data.pagination;
    target.totalElements = data.pagination.totalElements;
  },

  [board.BOARD_ARTICLE_RESET_STATE](state) {
    state.article = {};
  },

  [board.BOARD_ARTICLES_RESET_STATE](state) {
    state.articles = {
      isLoading: false,
      content: [],
      pagination: {},
      totalElements: 0,
    };
  },
  [board.BOARD_ARTICLES2_RESET_STATE](state) {
    state.articles2 = {
      isLoading: false,
      content: [],
      pagination: {},
      totalElements: 0,
    };
  },
  [board.BOARD_ARTICLES3_RESET_STATE](state) {
    state.articles3 = {
      isLoading: false,
      content: [],
      pagination: {},
      totalElements: 0,
    };
  },
};

export default mutations;
